import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Form } from "react-bootstrap";

import {
  errorMessages,
  addQuestionType,
  questionTypeConstants,
  addSurveyQuestionState,
  toastTypes,
  surveyQuestionTabsName,
  surveyQuestionValidation,
  textBoxCharLimit,
  BUTTON_TEXT,
} from "../../constants";
import { createNewGuid, customToast } from "../../../../shared/utility";
import {
  insertQuestionBeforeTrailingNps,
  hasMultipleQuestions,
} from "./utils/surveyQuestionHelpers";

const { STAR_RANKING_ID, TEXTBOX_ID } = questionTypeConstants;
const { questionOrder, surveyQuestionRecipients } = addSurveyQuestionState;
const AddNewQuestion = (props) => {
  const {
    setIsChanges,
    setQuestionList,
    setQuestionType,
    setShowAddQuestion,
    questionsAnswerArray,
    handleRecipientsUser,
    activeTab,
    isNpsFirstFullyActivated,
  } = props;

  const [checkedValues, setCheckedValues] = useState();

  //Handle Checkbox change
  const handleCheckboxChange = (event) => {
    const value = Number(event.target.value);
    setCheckedValues(value);
  };

  //New question to add
  const newQuestion = {
    questionOrder: questionOrder,
    questionTypeId:
      checkedValues === STAR_RANKING_ID ? STAR_RANKING_ID : TEXTBOX_ID,
    questionText: null,
    charLimit:
      checkedValues === STAR_RANKING_ID
        ? null
        : textBoxCharLimit || surveyQuestionValidation.DEFAULT_TEXTBOX_CHAR_LIMIT,
    surveyQuestionRecipients:
      checkedValues === TEXTBOX_ID ? [] : surveyQuestionRecipients,
    isNew: true,
    isEdit: false,
    guid: createNewGuid(),
  };

  //Function to handle add button
  const handleAddButton = () => {
    const isPOSQuestion = activeTab === surveyQuestionTabsName.inStore; // Determine once based on activeTab
    if (checkedValues) {
      setIsChanges(true);
      const questionToInsert = { ...newQuestion, isPOSQuestion };

      if (hasMultipleQuestions(questionsAnswerArray)) {
        //When NPS First is fully activated, insert before the last question
        //Otherwise, insert before the last 2 questions
        setQuestionList((prevList) => {
          const newArray = insertQuestionBeforeTrailingNps(
            prevList,
            questionToInsert,
            isNpsFirstFullyActivated,
          );
          return handleRecipientsUser(newArray);
        });
      } else {
        // Adding new question
        setQuestionList((prevList) => [...prevList, questionToInsert]);
      }
      setShowAddQuestion(false);
    } else {
      customToast(errorMessages.SELECT_ONE_PLEASE, toastTypes.ERROR);
    }
  };

  //Function to handle cancel button
  const handleCancelButton = () => {
    setQuestionType(null);
    setShowAddQuestion(false);
  };

  return (
    <div className="py-3" data-testid="add-new-question-container">
      <div className="notification-form shadow card">
        <div className="question-label green-background-color ms-auto">
          New Question
        </div>
        <div className="card-body main-question-div pt-0">
          <h5 className="fw-bold  px-2">Add Additional Question:</h5>
          <div className="bg-secondary bg-opacity-25 my-3 answer-heading1 py-2">
            <div className="align-items-center px-4">
              <span className="text-black answer-heading-text1 ">
                What type of question would you like to add?
              </span>
            </div>
          </div>
          {addQuestionType.map((radio) => (
            <Form.Check
              type="radio"
              key={radio.value}
              id={`question-type-${radio.value}`}
              value={radio.value}
              label={radio.label}
              name="questionToAdd"
              className="mt-2 questionTypeRadios px-4"
              checked={checkedValues === radio.value}
              onChange={handleCheckboxChange}
            />
          ))}
          <div className="d-flex justify-content-end  ps-4">
            <Button
              className="bg-secondary bg-opacity-25 border-0 text-dark py-1 me-2"
              onClick={handleCancelButton}
            >
              {BUTTON_TEXT.CANCEL}
            </Button>
            <Button
              className="py-1 green-background-color green-border"
              onClick={handleAddButton}
            >
              {BUTTON_TEXT.ADD}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  questionsAnswerArray: state.surveyQuestionsReducer.questionsAnswerArray,
});

export default connect(mapStateToProps)(AddNewQuestion);
